<script lang="ts" setup>
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';
import { AppFloatingLabelWrapper } from '~/components/base';
import type { FloatLabelVariant } from '~/types/components/base/FloatLabel';
import type {
  TextInputSize,
  TextInputVariant,
} from '~/types/components/base/TextInput';
import { IN } from '~/utils/enums/components/base/FloatLabel';

defineOptions({
  inheritAttrs: false,
});

/**
 * https://primevue.org/inputtext/#api.inputtext.props
 */
const {
  placeholder = undefined,
  label = undefined,
  variant = undefined,
  size = undefined,
  errorMessage = undefined,

  floatingLabel = true,
  floatingLabelVariant = IN,
  disabled = false,
  loading = false,
  invalid = false,
} = defineProps<{
  placeholder?: string;
  label?: string;
  variant?: TextInputVariant;
  size?: TextInputSize;
  errorMessage?: string;

  floatingLabel?: boolean;
  floatingLabelVariant?: FloatLabelVariant;
  disabled?: boolean;
  loading?: boolean;
  invalid?: boolean;
}>();
</script>

<template>
  <AppFloatingLabelWrapper
    :floating-label="floatingLabel"
    :floating-label-variant="floatingLabelVariant"
    :label="label"
  >
    <template #default="{ labelId: id }">
      <InputText
        :id="id"
        :variant="variant"
        :size="size"
        :disabled="disabled"
        :loading="loading"
        :invalid="invalid"
        :label="floatingLabel ? undefined : label"
        :placeholder="floatingLabel ? undefined : placeholder"
        class="app-input-text"
        v-bind="$attrs"
      />
    </template>
  </AppFloatingLabelWrapper>

  <Message
    v-if="!!errorMessage"
    severity="error"
    size="small"
    variant="simple"
    class="mt-2"
    >{{ errorMessage }}</Message
  >
</template>

<style lang="scss" scoped>
.app-input-text {
  &:focus {
    background-color: #f0ffff;
  }
}
</style>
